import { render, staticRenderFns } from "./ProjectTeamModules.vue?vue&type=template&id=5762b742&scoped=true"
import script from "./ProjectTeamModules.vue?vue&type=script&lang=js"
export * from "./ProjectTeamModules.vue?vue&type=script&lang=js"
import style0 from "./ProjectTeamModules.vue?vue&type=style&index=0&id=5762b742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5762b742",
  null
  
)

export default component.exports